// extracted by mini-css-extract-plugin
export var icon = "_r3-0";